<template>
  <div>
    <div>
      <p style="font-size: 24px;"><b>החברה "{{payload.company.name}}" נוצרה בהצלחה!</b></p>
      <div class="is-flex is-align-items-center is-justify-content-center action_buttons">
        <a @click="createNewPosition" class="button is-info">Create new Position</a>
        <a @click="editAccountingCompany" class="button is-info">Edit Accounting Company</a>
      </div>
    </div>
    <company-form-links style="text-align: center;" :company_id="payload.company.resource_id"></company-form-links>
    <div class="modal_footer">
      <a
        @click="remove(payload)"
        class="button is-info"
        >סיום</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import CompanyFormLinks from '@/components/CompanyFormLinks'
export default {
  name: 'create-company-step-four',
  props: ['payload'],
  created () {
    this.$network_utils.postStat(
      {
        designator: 'company_created',
        priority: 5,
        resource_type: 'Company',
        resource_id: this.payload.company.resource_id,
        owner: this.$utils.getOwner().name,
        title: 'Company Created'
      })
  },
  methods: {
    editAccountingCompany () {
      this.create({
        designator: 'accounting-company-form-modal',
        component_name: 'AccountingCompanyForm',
        company: this.payload.company,
        is_modal: true,
        modal_title: 'Accounting Company'
      })
    },
    createNewPosition () {
      this.create({
        designator: 'create-position-step-one',
        component_name: 'CreatePositionStepOne',
        ignore_escape_button: true,
        company_id: this.payload.company.resource_id,
        modal_title: 'Create Position'
      })
    },
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    CompanyFormLinks
  }
}
</script>
<style scoped>
  .action_buttons {
    margin-bottom: 10px;
    margin-bottom: 10px;
  }
  .action_buttons .button {
    margin-right: 10px;
    margin-left: 10px;
  }
</style>
